<mat-toolbar class="toolbar" fxLayout="row">
    <div>
        <img src="./assets/images/Logo-IC-transparente.png" alt="Logo IC" class="logo">
    </div>
    <div class="botonHome" fxFlex fxLayout="row" fxLayoutAlign="flex-end" *ngIf="!errorRuta">
        <app-boton-accion [datosProceso]="procesoFirma"></app-boton-accion>
    </div>
</mat-toolbar>

<mat-grid-list [cols]="columnas" rowHeight="100vh" (window:resize)="onResize($event)" *ngIf="!errorRuta">
    <mat-grid-tile [colspan]="colspanDocto" class="bodyDocto">
        <app-documento-vista [procesoFirma]="procesoFirma"></app-documento-vista> 
    </mat-grid-tile>
    <mat-grid-tile [colspan]="colspanFirmantes" class="bodyFirma">
        <app-firmantes [firmantes]="firmantes"></app-firmantes>
    </mat-grid-tile>
</mat-grid-list>
